<div #mapElement class="map" aria-label="Observer position map"></div>
